import type { ChartingRouteTab } from './chartingNoteOverlay.util'

/** Perio stays mounted after the first visit. Later dental edits do not rebuild the table. */
export const shouldMountPerioTable = (
  hasVisitedPerio: boolean,
  chartingTab: ChartingRouteTab,
): boolean => hasVisitedPerio || chartingTab === 'perio'
